import classNames from 'classnames';
import React from 'react';

import { Button } from '@/design-system/atoms/Button';

import styles from './Footer.module.scss';

export const PrivacyPreferencesLink = (props) => {
    const { linkLabel } = props;

    return (
        linkLabel &&
        linkLabel !== '' && (
            <li key={'privacy-policy'} className={styles['footer-utility__item']} role="none">
                <Button
                    onClick={(event) => {
                        event.preventDefault();
                        const OneTrust = window?.OneTrust || null;
                        OneTrust && OneTrust?.ToggleInfoDisplay();
                    }}
                    id="ot-sdk-link"
                    href={'#'}
                    target={'_self'}
                    className={classNames(styles[`footer-utility__link`])}
                    buttonStyle={Button.STYLE.TEXT_EXTRA_SMALL}
                    label={linkLabel}
                    aria-label={linkLabel}
                    role="menuitem"
                    analytics={{
                        componentName: 'Footer',
                        interactionType: 'footer',
                        selector: 'footer',
                    }}
                />
            </li>
        )
    );
};
